import React from 'react';
import PageWrapper from '../components/PageWrapper';

const About = ({ onNavigate }) => (
  <PageWrapper onNavigate={onNavigate} showFullFooter>
    <div className="page-hero">
      <p className="section-label">About Us</p>
      <h1>Who We Are</h1>
      <p>A premier African consulting firm rooted in expertise, ethics, and impact.</p>
    </div>

    {/* STORY */}
    <section className="section">
      <div className="container">
        <div className="grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
          <div>
            <p className="section-label">Our Story</p>
            <h2 className="section-title">Connecting Capital to Continent</h2>
            <div className="gold-line" />
            <p style={{ color: 'var(--muted)', lineHeight: 1.9, marginBottom: '1rem' }}>
              Founded in Hyderabad with operations across 18 African nations, Varahi Global Consulting was established with a singular vision — to be the most trusted bridge between global investors and Africa's extraordinary resource landscape.
            </p>
            <p style={{ color: 'var(--muted)', lineHeight: 1.9, marginBottom: '1rem' }}>
              Our team combines international financial acumen with deep on-ground African knowledge, enabling us to navigate complex regulatory environments, community dynamics, and market conditions with precision.
            </p>
            <p style={{ color: 'var(--muted)', lineHeight: 1.9 }}>
              We operate with integrity, transparency, and a long-term view — believing that sustainable wealth creation benefits both investors and African communities alike.
            </p>
          </div>
          <div style={{ background: 'var(--black)', padding: '3rem', textAlign: 'center' }}>
            <div style={{ fontSize: '5rem', marginBottom: '1.5rem' }}>🌍</div>
            <div className="stats-row" style={{ background: 'transparent', border: 'none' }}>
              <div className="stat-box" style={{ border: 'none' }}><span className="stat-num">2001</span><span className="stat-label">Founded</span></div>
              <div className="stat-box" style={{ border: 'none' }}><span className="stat-num">18</span><span className="stat-label">Countries</span></div>
            </div>
            <div className="stats-row" style={{ background: 'transparent', border: 'none', marginTop: '1rem' }}>
              <div className="stat-box" style={{ border: 'none' }}><span className="stat-num">80+</span><span className="stat-label">Team Members</span></div>
              <div className="stat-box" style={{ border: 'none' }}><span className="stat-num">4</span><span className="stat-label">Sectors</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* MISSION */}
    <section className="section" style={{ background: '#071a12', textAlign: 'center' }}>
      <div className="container">
        <p className="section-label">Our Mission</p>
        <h2 className="section-title white" style={{ textAlign: 'center' }}>Why We Exist</h2>
        <div className="gold-line center" />
        <p style={{ color: '#a8c4b4', maxWidth: '700px', margin: '0 auto', fontSize: '1.2rem', fontStyle: 'italic', lineHeight: 1.9, fontFamily: "'Playfair Display', serif" }}>
          "To unlock Africa's boundless potential through ethical consultancy, creating value for investors, nations, and communities — one project at a time."
        </p>
      </div>
    </section>

    {/* VALUES */}
    <section className="section" style={{ background: '#f9f7f3' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <p className="section-label">What Drives Us</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Our Core Values</h2>
          <div className="gold-line center" />
        </div>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {[
            { n: '01', title: 'Integrity', desc: 'We operate with the highest ethical standards in all engagements — with clients, governments, communities, and partners.' },
            { n: '02', title: 'Sustainability', desc: 'Long-term thinking drives every recommendation. We balance economic goals with environmental and social responsibility.' },
            { n: '03', title: 'Expertise', desc: 'Deep sectoral knowledge across mining, energy, trade, and tourism — backed by decades of African market experience.' },
            { n: '04', title: 'Partnership', desc: 'We don\'t just consult — we partner. Our success is measured by the success of those we work with.' },
          ].map(v => (
            <div key={v.n} className="value-item">
              <span className="value-num">{v.n}</span>
              <div>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="section" style={{ background: '#0d3d2a', textAlign: 'center' }}>
      <div className="container">
        <h2 className="section-title white" style={{ textAlign: 'center' }}>Work With Us</h2>
        <div className="gold-line center" />
        <p className="section-sub white center" style={{ marginBottom: '2rem' }}>Get in touch to explore how Varahi can support your Africa strategy.</p>
        <button className="btn-gold" onClick={() => onNavigate('contact')}>Contact Us</button>
        <button className="btn-outline" style={{ marginLeft: '1rem' }} onClick={() => onNavigate('team')}>Meet the Team</button>
      </div>
    </section>
  </PageWrapper>
);

export default About;
